export default (app) => {
  if (!Object.values(app.contentType).some((contentType) => contentType.clientDatabase === "wasm")) return;
  app.on("init", 100, async () => {
    const { default: memdbWasm } = await import("./database.js");
    await memdbWasm(app, true);
  });
};
